export default __webpack_public_path__ + "static/media/EM1450.34I-37417_-22060_0.ce08bf5e.jpg";